import { loggedIn } from '@/router/middlewares';

export default [
  {
    path: ':collectionId',
    name: 'collections',
    props: true,
    meta: {
      middleware: [loggedIn]
    },
    component: () => import(/* webpackChunkName: "apps" */ './page.vue'),
    children: [
      {
        path: ':id',
        name: 'collectionsTableComponent',
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "appTableComponent" */ './item/index.vue'
          ),
        meta: {
          rootRouteName: 'collections'
        }
      },
      {
        path: ':id/:nestedId',
        name: 'collectionsNestedComponent',
        props: true,
        component: () =>
          import(/* webpackChunkName: "appTableComponent" */ './item/index.vue')
      }
    ]
  },
  {
    path: '',
    redirect: { name: 'collections' }
  }
];
